import React from "react";
import StaffChangePassword from "../../components/StaffTabs/StaffChangePassword/StaffChangePassword";

const ChangePasswordPage = () => {
  return <StaffChangePassword />;
};

export default ChangePasswordPage;
